<template lang="pug">
  section.table-collapse
    collapse-component(
      :title="title",
      :tip="tip",
      :show-content="show",
      @toggle="toggle")
      template(slot="title")
        slot

      template(v-if="challengeMode && sectionDisabledMsg")
        lei-info-label(type="warning" :text="sectionDisabledMsg")

      template(v-if="tableLayout==='rel-lvl-2'")
        relationships(:type="type" :title="title")

      template(v-if="tableLayout === 'credentials'")
        credentials(:title="title")

      template(v-else-if="tableLayout==='rel-details'")
        relationship-details(:table-data="tableData" :type="type")

      template(v-else-if="tableLayout==='intervals'")
        relationship-intervals(:table-data="tableData" :type="type")

      template(v-else-if="tableLayout==='data-history'")
        historical-table(:table-data="tableData")

      template(v-else-if="tableLayout==='address'")
        address-cols(:items="tableData")

      template(v-else-if="tableLayout==='changes'")
        record-changes-block(:table-data="tableData" :extraField="extraField")

      template(v-else-if="tableLayout==='modifications'")
        record-modifications-block(:table-data="tableData")

      template(v-else-if="tableLayout==='events'")
        record-events-block(:table-data="tableData")

      template(v-else-if="tableData")
        table-row(
          v-for="(row, i) in tableData"
          :item="row"
          :key="i"
          :disabledRow="challengeMode && !!sectionDisabledMsg"
          )

</template>
<script>
import Challenge from '@/mixins/challenge'
import CollapseComponent from '../../lei-components/CollapseComponent'
import TableRow from './TableRow'
import HistoricalTable from './HistoricalTable'
import AddressCols from '../address/AddressCols'
import Relationships from '../Relationships'
import RelationshipDetails from './RelationshipDetails'
import RelationshipIntervals from './RelationshipIntervals'
import LeiInfoLabel from '@/components/lei-components/LeiInfoLabel'
import RecordModificationsBlock from '@/components/record-details/modifications/RecordModificationsBlock'
import RecordChangesBlock from '@/components/record-details/modifications/RecordChangesBlock'
import Credentials from '@/components/record-details/credentials/Credentials'

import RecordEventsBlock from '@/components/record-details/modifications/RecordEventsBlock'

export default {
  components: {
    LeiInfoLabel,
    RelationshipIntervals,
    RelationshipDetails,
    Relationships,
    AddressCols,
    HistoricalTable,
    TableRow,
    CollapseComponent,
    RecordModificationsBlock,
    RecordEventsBlock,
    RecordChangesBlock,
    Credentials,
  },
  mixins: [ Challenge, ],
  props: {
    tableData: {
      type: [ Array, Object, ],
      required: true,
    },
    tableLayout: {
      type: String,
      default: 'default',
      validate: (value) => {
        return [
          'default',
          'address',
          'data-history',
          'rel-lvl-2',
          'rel-details',
          'intervals',
          'modifications',
        ]
          .includes(value)
      },
    },
    showContent: {
      type: Boolean,
      default: undefined,
    },
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'directParent',
      validator: (value) => [
        'directParent',
        'ultimateParent',
        'fundManager',
        'umbrellaFund',
        'masterFund',
        'headOffice',
      ].includes(value),
    },
    tip: {
      type: Object,
      default: () => ({
        small: '',
        full: '',
      }),
    },
    sectionDisabledMsg: {
      type: String,
      default: undefined,
    },
    extraField: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      localToggleState: true,
    }
  },
  computed: {
    show () {
      return typeof this.showContent !== 'undefined' ? this.showContent : this.localToggleState
    },
  },
  methods: {
    toggle () {
      if (typeof this.showContent !== 'undefined') {
        this.$emit('toggle', this.showContent)
      } else {
        this.localToggleState = !this.localToggleState
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../../assets/styles/variables.styl"

  .mb-10
    margin-bottom 10px
    
  @media screen and (max-width: $tablet)
    .table-collapse
      padding 15px 0
</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/TableCollapse.vue